<app-spotlight-full-page-loader *ngIf="isLoading" page='groupsharing'></app-spotlight-full-page-loader>
<app-video-player (durationVideoTime)="durationVideoTime($event)" *ngIf="isSlowMotionGraphicsLoading"
    [first_video]='first_video' [second_video]='second_video' [event_id]='eventId'></app-video-player>
<div style="display: flex;justify-content: center;    position: relative;
z-index: 1;">
    <span class="cinejoy-title">cinejoy</span>

</div>
<div class="welcome-text" style="display: flex;justify-content: center;"
    *ngIf="!meetingStarted && !isSlowMotionGraphicsLoading">
    <div class="cus-welcome-msg"><span class="cus-movie-name">Welcome to <span
                class="highlight-movie-name">{{cinejoyPremierDetails?.name}}</span> Group Sharing Experience</span>
    </div>

</div>
<div class="welcome-text" style="display: flex;justify-content: center;"
    *ngIf="!meetingStarted && activateCounter && !isSlowMotionGraphicsLoading">
    <div class="cus-welcome-msg-recarpet-timer" style="top:calc(18% + 70px)"><span class="cus-movie-name">End Of
            Festivities starts in <span class="highlight-movie-name">{{timeLeft | countdown}} mins</span> </span></div>

</div>
<div class="welcome-text" style="display: flex;justify-content: center;"
    *ngIf="meetingStarted && activateCounter && !isSlowMotionGraphicsLoading">
    <div class="cus-welcome-msg-meeting-started"><span class="cus-movie-name">End of Festivities and Group Sharing ends
            in <span class="highlight-movie-name">{{timeLeft | countdown}} mins</span></span></div>
    <div class="cus-welcome-msg-meeting-started sub-text"><span class="cus-movie-name">Lobby experience will end shortly,
            <br />you can watch the movie again.</span></div>


</div>

<div class="warning-text" style="display: flex;justify-content: center;" *ngIf="!isSlowMotionGraphicsLoading">
    <div class="cus-warning-msg"><span class="cus-movie-name">To enjoy the Group Sharing Experience please switch to
            desktop/laptop</span></div>

</div>
<div class="welcome-text" style="display: flex;justify-content: center"
    *ngIf="!meetingStarted && !isSlowMotionGraphicsLoading && isSessionAvailable">
    <div class="cus-warning-msg" style="top:60%"><span class="cus-movie-name">Please wait untill we join you to the same
            group</span></div>

</div>
<div class="body" *ngIf="!isSlowMotionGraphicsLoading && !isLoading">
    <!--  <img class="lobby-bg-image" src="assets/icons/group-sharing/Rectangle 8.svg">-->
    <div class="flex-container " *ngIf="!meetingStarted && !isSessionAvailable">
        <!-- <div> -->
        <button *ngIf="!exsistingGroup" (click)="openDialog()" title="Create Group sharing experience with friends"
            class="btn btn-light cre-grp-btn ">Create Group</button>
        <button id="startGrpBtn" *ngIf="exsistingGroup" (click)="joinExsistingGroup()"
            title="Create Group sharing experience with friends" class="btn btn-light cre-grp-btn ">Start Group</button>
        <!-- </div> -->
        <!--   <div class="cus-join-layout" style="" *ngIf="eventsList.length">

            <h2 style="color: white;">Join Group</h2>
            <mat-divider></mat-divider>
            <mat-list *ngIf="eventsList.length">
                <mat-list-item style="text-align: left;" *ngFor="let item of eventsList">
                    <h3 matLine> {{item.description | titlecase}}</h3>
                    <h3 matLine>
                        Created By: {{item.hostFirstName | titlecase }}
                    </h3>
                    <button mat-icon-button (click)="joinGroupEvent(item)" [disabled]="join_btn">
                        Join
                    </button>

                    <mat-divider></mat-divider>

                </mat-list-item>
            </mat-list>
        </div>-->
        <!-- <div  style="margin-top:20px;width: 229px;"> -->
        <mat-accordion *ngIf="eventsList.length">
            <mat-expansion-panel style="background-color: #DE1B36;">
                <mat-expansion-panel-header style="background: #DE1B36;
                  font-family: 'Poppins Regular';
                  height: 68px;
                  border-radius: 5px;">
                    <mat-panel-title style="font-size: 24px;
                    font-weight: 500;
                    line-height: 30px;color: white;">
                        Join Group
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <mat-list *ngIf="eventsList.length">
                    <mat-list-item style="text-align: left;" *ngFor="let item of eventsList">
                        <h3 matLine style="    white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            max-width: 200px;"> {{item.description | titlecase}}</h3>
                        <h3 matLine>
                            Created By: {{item.hostFirstName | titlecase }}
                        </h3>
                        <button
                            style="color: white;
                        box-shadow: 3px;margin: 10px;    border: 1px solid white;
                        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);"
                            mat-button (click)="joinGroupEvent(item)">
                            Join
                        </button>
                        <mat-divider></mat-divider>

                    </mat-list-item>
                </mat-list>
            </mat-expansion-panel>
        </mat-accordion>
        <!-- </div> -->

    </div>

    <!--   <div fxLayout="row wrap" class="custom-layout" *ngIf="meetingStarted">
        <div class="row custom-video-box">
            <div fxFlex="18" fxFlex.sm="33.3" fxFlex.xs="50" class="flex-wrap" id="videoContainer">
               <div cols="2" style="height: 30px;" id="videoWrapper">

                </div>
            </div>
        </div>

    </div>-->

    <div class="lobbycontainer" style=" display: flex !important;flex-wrap: wrap !important;column-gap: 15px !important;row-gap: 15px !important;justify-content: center;align-items: center;height: 460px;margin-top: 10%;
        overflow: hidden;
        overflow-y: auto;" *ngIf="meetingStarted" #videoContainer>


        <!--  <div
        [ngClass]="{
          'five-items-row' : (users.length > 8 && users.length <= 10),
          'six-items-row' : (users.length > 10 && users.length <= 12),
          'seven-items-row' : users.length > 12
        }"
        class="profile"
        >

        </div>-->
    </div>
    <div *ngIf="meetingStarted">
        <div class="grp-container" fxLayout="row">
            <div fxLayout="row" fxLayoutGap="2%" class="btnContainer">
                <button title="End call" style="background: #DE1B36;" mat-raised-button
                    aria-label="Example icon button with a home icon" (click)="leaveMeeting()">
                    <img style="width: 28px;" src="assets/icons/group-sharing/call_end.svg">
                </button>
                <button title="Participants" style="background: #DE1B36;" mat-raised-button
                    aria-label="Example icon button with a home icon" (click)="openParticipantTemplate()">
                    <img style="width: 28px;" src="assets/icons/group-sharing/groups.svg">
                </button>
            </div>
        </div>
    </div>
</div>

<ng-template #participantList>
    <div class="bottom-sheet-header">{{eventDetails?.description | titlecase}}
        <img style="width: 20px;cursor: pointer;position: absolute;right: 7px;" (click)="closeBottomSheet()"
            src="assets/icons/group-sharing/cancel-white.svg">
    </div>
    <mat-form-field class="example-chip-list" appearance="fill" *ngIf="hostUser" style="width:100%">
        <mat-label>Add Group Participants</mat-label>
        <mat-chip-list #chipList aria-label="Fruit selection">
            <input class="cus-search-users" placeholder="Enter User Name" #fruitInput [formControl]="myControl"
                [matAutocomplete]="auto" [matChipInputFor]="chipList">
        </mat-chip-list>
        <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.userId">
                <span class="cus-bottom-autocomplete" [title]="option.value">{{option.value}}</span>
                <span title="Request to Join">
                    <button mat-button class="btn-join-grp" color="primary"
                        (click)="addParticipantsToExsistingEvent(option.userId)">Request to Join</button>
                </span>
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-list #participantsList id="participantsList">
        <!--<span> Participants ({{totalParticipant}})</span>   -->
        <mat-list-item style="color: black !important;">
            <span class="cus-name-list"
                title="{{meeting.localParticipant.displayName | titlecase}}">{{meeting.localParticipant.displayName |
                titlecase}} <ng-container *ngIf="getIsUserHost(meeting.localParticipant)"
                    style="margin: 12px 10px 12px !important;">(Host)</ng-container> </span>
            <span class="cus-icon-container">
                <img style="width: 18px; margin-right: 5px;cursor: pointer;" (click)="toggleWebCam($event)"
                    id="listLocalVideo" [src]="webCamEnable ? videocam_on :  videocam_off" alt="" #listLocalVideo>
                <img style="width: 20px;cursor: pointer;" (click)="toggleMic($event)"
                    [src]="micEnable ? mic_on : mic_off" id="listLocalAudio" alt="" #listLocalAudio>
                <img style="width: 20px;cursor: pointer;" [src]="menu_icon" [matMenuTriggerFor]="menu"
                    *ngIf="webcams.length > 1">
                <mat-menu #menu="matMenu">
                    <button mat-menu-item [matMenuTriggerFor]="vertebrates">
                        <span>Change Camera</span>
                    </button>

                </mat-menu>
                <mat-menu #vertebrates="matMenu">
                    <button mat-menu-item *ngFor="let item of webcams"
                        (click)="changeWebcam(item)">{{item.label}}</button>
                </mat-menu>
            </span>
        </mat-list-item>
        <mat-list-item style="color: black !important;" *ngFor="let item of meeting.participants | keyvalue">
            {{getDisplayName(item).displayName | titlecase}} <ng-container
                *ngIf="getIsUserHost(item)">(Host)</ng-container>
            <span class="cus-icon-container" *ngIf="hostUser">
                <img style="width: 18px; margin-right: 5px;cursor: pointer;" (click)="toggleWebCam($event)"
                    [attr.id]="getControlValue('video', item)"
                    [src]="getDisplayName(item)?.webcamOn ? videocam_on :  videocam_off" alt="">
                <img style="width: 20px;cursor: pointer;" (click)="toggleMic($event)"
                    [attr.id]="getControlValue('mic', item)" [src]="getDisplayName(item)?.micOn ? mic_on : mic_off"
                    alt="">
                <img style="width: 20px;cursor: pointer;" [src]="menu_icon" [matMenuTriggerFor]="menu">
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="removeParticipant(item)">
                        <span>Remove User</span>
                    </button>

                </mat-menu>
            </span>

        </mat-list-item>
    </mat-list>
</ng-template>